module.exports = __webpack_public_path__ + "static/media/bg3.e1e5ac40.jpg";